const language = {
    'pt': 
        {
            add_new:            'Adicionar novo',
            archive:            'Arquivo',
            avaiable:           'Disponível até',
            abstract:           'Resumo',
            cancel:             'Cancelar', back: 'Voltar',
            close:              'Fechar',
            content:            'Licença',
            content_add:        'Adicionar bloco',
            choose_category:    'Pressione ENTER para escolher a categoria',
            content_edit:       'Editar conteúdo',
            content_new:        'Novo conteúdo',
            content_list:       'Lista de Licença', 
            dates:              'Datas',
            date_creation:      'Criação',
            date_avaiable:      'Disponível até',
            date_publication:   'Publicação',
            date_last_update:   'Última atualização',
            delete:             'Eliminar',
            delete_title:       'Eliminar registo',
            delete_text:        'Continuar?',
            delete_confirm:     'Sim',
            delete_cancel:      'Não',
            delete_error:       'Problema ao apagar registo!',
            delete_success:     'Registo apagado com sucesso!',
            description:        'Descrição',
            draft:              'Rascunho',
            doc_choose:         'Carregar PDFs',
            edit:               'Editar',
            edit_title:         'Editar registo',
            edit_text:          'Continuar?',
            edit_confirm:       'Sim',
            edit_cancel:        'Não',
            edit_error:         'Problema ao atualizar registo!',
            edit_success:       'Registo atualizado com sucesso!',
            file_attach:        'Attach file',
            file_remove_all:    'Remove all',
            file_upload:        'Upload file',
            file_upload_all:    'Upload all',
            filter_placeholder: 'Procurar',
            id:                 'ID',
            layout:             'Tipo',
            multimedia:         'Multimédia',
            name:               'Nome',
            name_placeholder:   'Introduza o nome',
            partners:           'Licença',
            partners_add:       'Adicionar bloco',
            partners_edit:      'Editar Licença',
            partners_new:       'Novo Licença',
            partners_list:      'Lista de Licença',
            image:              'Imagem em destaque',
            images:             'Imagens',
            image_choose:       'Carregar imagens',
            insert_title:       'Novo registo',
            insert_text:        'Continuar?',
            insert_confirm:     'Sim',
            insert_cancel:      'Não',
            insert_error:       'Problema ao inserir registo!',
            insert_success:     'Registo inserido com sucesso!',
            page_config:        'Configuração da Página',
            page_parent:        'Parent',
            pages:              'Páginas',
            pdf_documents:      'Documentos PDF',
            preview:            'Pré-visualização',
            principal:          'Principal',
            published:          'Publicado',
            remove:             'Remover',
            schedule:           'Agendar',
            schedule_to:        'Agendado',
            seo_config:         'Configuração SEO',
            seo_description:    'Descrição SEO',
            seo_description_placeholder: 'Introduza a descrição',
            seo_keywords:       'Palavras-chave SEO ',
            seo_keywords_small: '(separar com vírgulas)',
            seo_keywords_placeholder: 'Introduza as palavras-chave',
            seo_title:          'Título SEO',
            seo_title_placeholder: 'Introduza o título SEO',
            table_rows_per_page:'Registos por página:',
            table_separator:    'de',
            table_all:          'Todos',
            table_title:        'Título',
            table_parent:       'Parent',
            table_date:         'Data',
            table_date_published: 'Data de publicação',
            table_state:        'Estado',
            table_actions:      'Ações',
            text:               'Texto',
            title:              'Título',
            title_placeholder:  'Introduza o título',
            save:               'Salvar',     
            subtitle:           'Subtítulo',
            subtitle_placeholder:  'Introduza o subtítulo',
            tlf:                'Tlf',
            tlf_placeholder:    'Introduza Tlf',
            tlm:                'Tlm',
            tlm_placeholder:    'Introduza Tlm',
            fax:                'Fax',
            fax_placeholder:    'Introduza Fax',
            email:              'E-mail',
            email_placeholder:  'Introduza E-mail',
            morada:             'Morada',
            morada_placeholder: 'Introduza a morada',
            website:                'Website',
            website_placeholder:    'Introduza Website',
            to_eat:             'Onde Comer',
            to_sleap:           'Onde Dormir',
            partner_types:      'Tipo',
            youtube_choose:      'Youtube',   
            upload_file_error:  'O ficheiro tem mais de 10MB.',

            client:             'Cliente',
            software:           'Software',
            users:              'Utilizadores',
            version:            'Versão',
            serie:              'N.º de Série',
            qtd:                'Qtd',
            license_date_begin: 'Data de Licenciamento',
            license_date_to:    'a',
            license_date_end:   'Data de fim',

            license_title:              'Certificado de Licenciamento de Software',
            license_msg:                'Declara-se que o software abaixo designado está licenciado a:',
            license_table_software:     'Software ASSEC-SIM! Licenciado',
        },
    'en':
        {
            add_new:            'Add new',
            archive:            'Archive',
            avaiable:           'Avaiable until',
            abstract:           'Abstract',
            cancel:             'Cancel', back: 'Voltar',
            close:              'Close',
            content:            'Partners',
            content_add:        'Add block',
            choose_category:    'Press enter to add new tag',
            content_edit:       'Edit content',
            content_new:        'New content',
            content_list:       'Partners list',
            dates:              'Dates',
            date_creation:      'Creation',
            date_avaiable:      'Avaiable until',
            date_publication:   'Publication',
            date_last_update:   'Last update',
            delete:             'Delete',
            delete_title:       'Delete Regist',
            delete_text:        'Are you sure you want to continue?',
            delete_confirm:     'Yes',
            delete_cancel:      'No',
            delete_error:       'Problem deleting the element!',
            delete_success:     'Element deleted successfully!',
            description:        'Description',
            draft:              'Draft',
            doc_choose:         'Choose PDF',
            edit:               'Edit',
            edit_title:         'Edit Regist',
            edit_text:          'Are you sure you want to continue?',
            edit_confirm:       'Yes',
            edit_cancel:        'No',
            edit_error:         'Problem updating element!',
            edit_success:       'Successful updated element!',
            file_attach:        'Attach file',
            file_remove_all:    'Remove all',
            file_upload:        'Upload file',
            file_upload_all:    'Upload all',
            filter_placeholder: 'Search',
            id:                 'ID',
            layout:             'Type',
            multimedia:         'Multimedia',
            name:               'Name',
            name_placeholder:   'Insert the name',
            partners:           'Parceitos',
            partners_add:       'Adicionar bloco',
            partners_edit:      'Editar Licença',
            partners_new:       'Novo Licença',
            partners_list:      'Lista de Licença',
            image:              'Highlight image',
            images:             'Images',
            image_choose:       'Choose image',
            insert_title:       'New Regist',
            insert_text:        'Are you sure you want to continue?',
            insert_confirm:     'Yes',
            insert_cancel:      'No',
            insert_error:       'Problem updating element!',
            insert_success:     'Successful updated element!',
            page_config:        'Page config',
            page_parent:        'Parent',
            pages:              'Pages',
            pdf_documents:      'PDF Documents',
            preview:            'Preview',
            principal:          'Principal',
            published:          'Publicado',
            remove:             'Remove',
            schedule:           'Schedule',            
            schedule_to:        'Schedule', 
            seo_config:         'SEO config',
            seo_description:    'SEO description',
            seo_description_placeholder: 'Insert the SEO description',
            seo_keywords:       'SEO keywords',
            seo_keywords_small: '(separate by comma)',
            seo_keywords_placeholder: 'Insert the SEO keywords',
            seo_title:          'SEO title',
            seo_title_placeholder: 'Insert the SEO title',
            table_rows_per_page:'Regist by page:',
            table_separator:    'of',
            table_all:          'All',
            table_title:        'Title',
            table_parent:       'Parent',
            table_date:         'Date',
            table_date_published: 'Published date',
            table_state:        'State',
            table_actions:      'Actions',
            text:               'Text',
            title:              'Title',
            title_placeholder:  'Insert title',
            save:               'Save',
            subtitle:           'Subtitle',
            subtitle_placeholder:  'Insert subtitle',  
            tlf:                'Tlf',
            tlf_placeholder:    'Introduzir Tlf',
            tlm:                'Tlm',
            tlm_placeholder:    'Introduzir Tlm',
            fax:                'Fax',
            fax_placeholder:    'Introduzir Fax',
            email:              'E-mail',
            email_placeholder:  'Introduzir E-mail',
            morada:             'Morada',
            morada_placeholder: 'Introduza a morada',
            website:                'Website',
            website_placeholder:    'Introduzir Website',
            to_eat:             'Onde Comer',
            to_sleap:           'Onde Dormir',
            partner_types:      'Tipo',
            youtube_choose:      'Youtube',   
            upload_file_error:  'O ficheiro tem mais de 10MB.',

            client:             'Cliente',
            software:           'Software',
            users:              'Utilizadores',
            version:            'Versão',
            serie:              'N.º de Série',
            qtd:                'Qtd',
            license_date_begin: 'Data de Licenciamento',
            license_date_to:    'a',
            license_date_end:   'Data de fim',

            license_title:              'Certificado de Licenciamento de Software',
            license_msg:                'Declara-se que o software abaixo designado está licenciado a:',
            license_table_software:     'Software ASSEC-SIM! Licenciado',
        }, 'es':
        {
            add_new: 'Añadir nuevo',
    archive: 'Archivo',
    avaiable: 'Disponible hasta',
    abstract: 'Resumen',
    cancel: 'Cancelar', back: 'Voltar',
    close: 'Cerrar',
    content: 'Licença',
    content_add: 'Añadir bloque',
    choose_category: 'Presione ENTER para elegir la categoría',
    content_edit: 'Editar contenido',
    content_new: 'Nuevo contenido',
    content_list: 'Lista de Licença',
    dates: 'Fechas',
    date_creation: 'Creación',
    date_avaiable: 'Disponible hasta',
    date_publication: 'Publicación',
    date_last_update: 'Última actualización',
    delete: 'Eliminar',
    delete_title: 'Eliminar registro',
    delete_text: '¿Continuar?',
    delete_confirm: 'Sí',
    delete_cancel: 'No',
    delete_error: '¡Problema al eliminar el registro!',
    delete_success: '¡Registro eliminado con éxito!',
    description: 'Descripción',
    draft: 'Borrador',
    doc_choose: 'Cargar PDFs',
    edit: 'Editar',
    edit_title: 'Editar registro',
    edit_text: '¿Continuar?',
    edit_confirm: 'Sí',
    edit_cancel: 'No',
    edit_error: '¡Problema al actualizar el registro!',
    edit_success: '¡Registro actualizado con éxito!',
    file_attach: 'Adjuntar archivo',
    file_remove_all: 'Eliminar todo',
    file_upload: 'Subir archivo',
    file_upload_all: 'Subir todos',
    filter_placeholder: 'Buscar',
    id: 'ID',
    layout: 'Tipo',
    multimedia: 'Multimedia',
    name: 'Nombre',
    name_placeholder: 'Introduzca el nombre',
    partners: 'Licença',
    partners_add: 'Añadir bloque',
    partners_edit: 'Editar Licença',
    partners_new: 'Nuevo Licença',
    partners_list: 'Lista de Licença',
    image: 'Imagen destacada',
    images: 'Imágenes',
    image_choose: 'Cargar imágenes',
    insert_title: 'Nuevo registro',
    insert_text: '¿Continuar?',
    insert_confirm: 'Sí',
    insert_cancel: 'No',
    insert_error: '¡Problema al insertar el registro!',
    insert_success: '¡Registro insertado con éxito!',
    page_config: 'Configuración de Página',
    page_parent: 'Padre',
    pages: 'Páginas',
    pdf_documents: 'Documentos PDF',
    preview: 'Vista previa',
    principal: 'Principal',
    published: 'Publicado',
    remove: 'Eliminar',
    schedule: 'Programar',
    schedule_to: 'Programado',
    seo_config: 'Configuración SEO',
    seo_description: 'Descripción SEO',
    seo_description_placeholder: 'Introduzca la descripción',
    seo_keywords: 'Palabras clave SEO',
    seo_keywords_small: '(separadas por comas)',
    seo_keywords_placeholder: 'Introduzca las palabras clave',
    seo_title: 'Título SEO',
    seo_title_placeholder: 'Introduzca el título SEO',
    table_rows_per_page: 'Registros por página:',
    table_separator: 'de',
    table_all: 'Todos',
    table_title: 'Título',
    table_parent: 'Padre',
    table_date: 'Fecha',
    table_date_published: 'Fecha de publicación',
    table_state: 'Estado',
    table_actions: 'Acciones',
    text: 'Texto',
    title: 'Título',
    title_placeholder: 'Introduzca el título',
    save: 'Guardar',
    subtitle: 'Subtítulo',
    subtitle_placeholder: 'Introduzca el subtítulo',
    tlf: 'Tlf',
    tlf_placeholder: 'Introduzca Tlf',
    tlm: 'Tlm',
    tlm_placeholder: 'Introduzca Tlm',
    fax: 'Fax',
    fax_placeholder: 'Introduzca Fax',
    email: 'Correo electrónico',
    email_placeholder: 'Introduzca Correo electrónico',
    morada: 'Dirección',
    morada_placeholder: 'Introduzca la dirección',
    website: 'Sitio web',
    website_placeholder: 'Introduzca Sitio web',
    to_eat: 'Dónde Comer',
    to_sleap: 'Dónde Dormir',
    partner_types: 'Tipo',
    youtube_choose: 'Youtube',
    upload_file_error: 'El archivo supera los 10MB.',

            client:             'Cliente',
            software:           'Software',
            users:              'Utilizadores',
            version:            'Versão',
            serie:              'N.º de Série',
            qtd:                'Qtd',
            license_date_begin: 'Data de Licenciamento',
            license_date_to:    'a',
            license_date_end:   'Data de fim',

            license_title:              'Certificado de Licenciamento de Software',
            license_msg:                'Declara-se que o software abaixo designado está licenciado a:',
            license_table_software:     'Software ASSEC-SIM! Licenciado',
        },
         'fr':
        {
             add_new: 'Ajouter nouveau',
    archive: 'Archive',
    avaiable: 'Disponible jusqu\'à',
    abstract: 'Résumé',
    cancel: 'Annuler',
    close: 'Fermer',
    content: 'Licença',
    content_add: 'Ajouter un bloc',
    choose_category: 'Appuyez sur ENTRÉE pour choisir la catégorie',
    content_edit: 'Modifier le contenu',
    content_new: 'Nouveau contenu',
    content_list: 'Liste de Licença',
    dates: 'Dates',
    date_creation: 'Création',
    date_avaiable: 'Disponible jusqu\'à',
    date_publication: 'Publication',
    date_last_update: 'Dernière mise à jour',
    delete: 'Supprimer',
    delete_title: 'Supprimer l\'enregistrement',
    delete_text: 'Continuer ?',
    delete_confirm: 'Oui',
    delete_cancel: 'Non',
    delete_error: 'Problème lors de la suppression de l\'enregistrement !',
    delete_success: 'Enregistrement supprimé avec succès !',
    description: 'Description',
    draft: 'Brouillon',
    doc_choose: 'Charger des PDFs',
    edit: 'Modifier',
    edit_title: 'Modifier l\'enregistrement',
    edit_text: 'Continuer ?',
    edit_confirm: 'Oui',
    edit_cancel: 'Non',
    edit_error: 'Problème lors de la mise à jour de l\'enregistrement !',
    edit_success: 'Enregistrement mis à jour avec succès !',
    file_attach: 'Joindre un fichier',
    file_remove_all: 'Tout supprimer',
    file_upload: 'Téléverser un fichier',
    file_upload_all: 'Tout téléverser',
    filter_placeholder: 'Rechercher',
    id: 'ID',
    layout: 'Type',
    multimedia: 'Multimédia',
    name: 'Nom',
    name_placeholder: 'Entrez le nom',
    partners: 'Licença',
    partners_add: 'Ajouter un bloc',
    partners_edit: 'Modifier Licença',
    partners_new: 'Nouveau Licença',
    partners_list: 'Liste de Licença',
    image: 'Image à la une',
    images: 'Images',
    image_choose: 'Charger des images',
    insert_title: 'Nouvel enregistrement',
    insert_text: 'Continuer ?',
    insert_confirm: 'Oui',
    insert_cancel: 'Non',
    insert_error: 'Problème lors de l\'insertion de l\'enregistrement !',
    insert_success: 'Enregistrement inséré avec succès !',
    page_config: 'Configuration de la page',
    page_parent: 'Parent',
    pages: 'Pages',
    pdf_documents: 'Documents PDF',
    preview: 'Aperçu',
    principal: 'Principal',
    published: 'Publié',
    remove: 'Retirer',
    schedule: 'Planifier',
    schedule_to: 'Planifié',
    seo_config: 'Configuration SEO',
    seo_description: 'Description SEO',
    seo_description_placeholder: 'Entrez la description',
    seo_keywords: 'Mots-clés SEO',
    seo_keywords_small: '(séparés par des virgules)',
    seo_keywords_placeholder: 'Entrez les mots-clés',
    seo_title: 'Titre SEO',
    seo_title_placeholder: 'Entrez le titre SEO',
    table_rows_per_page: 'Enregistrements par page :',
    table_separator: 'de',
    table_all: 'Tous',
    table_title: 'Titre',
    table_parent: 'Parent',
    table_date: 'Date',
    table_date_published: 'Date de publication',
    table_state: 'État',
    table_actions: 'Actions',
    text: 'Texte',
    title: 'Titre',
    title_placeholder: 'Entrez le titre',
    save: 'Enregistrer',
    subtitle: 'Sous-titre',
    subtitle_placeholder: 'Entrez le sous-titre',
    tlf: 'Tél',
    tlf_placeholder: 'Entrez Tél',
    tlm: 'Mobile',
    tlm_placeholder: 'Entrez Mobile',
    fax: 'Fax',
    fax_placeholder: 'Entrez Fax',
    email: 'E-mail',
    email_placeholder: 'Entrez l\'e-mail',
    morada: 'Adresse',
    morada_placeholder: 'Entrez l\'adresse',
    website: 'Site web',
    website_placeholder: 'Entrez le site web',
    to_eat: 'Où Manger',
    to_sleap: 'Où Dormir',
    partner_types: 'Type',
    youtube_choose: 'Youtube',
    upload_file_error: 'Le fichier dépasse 10 Mo.',

            client:             'Cliente',
            software:           'Software',
            users:              'Utilizadores',
            version:            'Versão',
            serie:              'N.º de Série',
            qtd:                'Qtd',
            license_date_begin: 'Data de Licenciamento',
            license_date_to:    'a',
            license_date_end:   'Data de fim',

            license_title:              'Certificado de Licenciamento de Software',
            license_msg:                'Declara-se que o software abaixo designado está licenciado a:',
            license_table_software:     'Software ASSEC-SIM! Licenciado',
        }
}

module.exports = {
    language
};